module.exports = __webpack_public_path__ + "static/media/website.59952575.png";